import { useSelector } from 'react-redux';

import { CurrencyDetails } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProvider/apis';
import { SelectedProvider } from '@provider-portal/common/services/types/account';
import type { Nullable } from '@provider-portal/common/types/types';

import { selectSelectedProvider } from 'rdx/account';

export function useSelectedProvider(): Nullable<SelectedProvider> {
  const selectedProvider = useSelector(selectSelectedProvider);
  return selectedProvider ?? null;
}

export function useSelectedProviderId(): Nullable<number> {
  const selectedProvider = useSelectedProvider();
  return selectedProvider?.providerId || null;
}

export function useSelectedProviderCurrency(): Nullable<CurrencyDetails> {
  const selectedProvider = useSelectedProvider();
  return selectedProvider?.currency || null;
}
